import React from 'react'; 
import { Outlet } from 'react-router-dom';
import Header from '../components/header';
import Footer from '../components/footer';
import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet'; 

const Mainlayout = () => {
  return (
    <>

     <Helmet>
        <meta charSet="utf-8" />
        <title>finaculator</title>
        <meta name="description" content="Calculate your finances with our comprehensive tools, including EMI, SIP, FD, and RD calculators." />
        <meta name="keywords" content="Financial Calculator, Interest Calculator, EMI Calculator, SIP Calculator, Fixed Deposit Calculator, Recurring Deposit Calculator, Lump Sum Calculator, Loan Calculator, Mortgage Calculator" />
        <meta name="author" content="CHS software solutions" />
      </Helmet>

      <Header />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          backgroundColor: '#f0f0f0', 
          width: '100%', 
          padding: 0, 
        }}
      >
       
        <Box sx={{ marginTop: '50px', flexGrow: 1 }}> 
          <Outlet />
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default Mainlayout;
